import { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";

export function LoadingOverlay({ delay = 3500 }: { delay?: number }) {
  const [show, setShow] = useState(false);
  const { t } = useTranslation();

  const messages = t("LoadingOverlay.messages", { returnObjects: true }) as {
    title: string;
    subtitle: string;
  }[];

  const index = useMemo(
    () => Math.floor(Math.random() * messages.length),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );

  const message = messages[index];

  useEffect(() => {
    const timer = setTimeout(() => setShow(true), delay);
    return () => clearTimeout(timer);
  }, [delay]);

  if (!show) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center z-30 pointer-events-none animate-[fadeIn_0.4s_ease-out]">
      <div className="bg-gray-900/95 border border-gray-600 rounded-xl px-8 py-6 text-center shadow-2xl backdrop-blur-sm">
        <svg
          className="animate-spin h-8 w-8 text-indigo-400 mx-auto mb-3"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
        >
          <circle
            className="opacity-25"
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            strokeWidth="4"
          />
          <path
            className="opacity-75"
            fill="currentColor"
            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
          />
        </svg>
        <div className="text-gray-100 text-lg font-semibold">
          {message.title}
        </div>
        <p className="text-gray-400 text-sm mt-1">
          {message.subtitle}
        </p>
      </div>
    </div>
  );
}
